import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

const AxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: API_URL,
    timeout: 1000 * 60
  });

  axiosInstance.interceptors.request.use((request) => {
    const currentToken = JSON.parse(localStorage.getItem('auth')!)?.accessToken;
    if (currentToken && request.url !== (`${API_URL}/auth/login`)) {
      request.headers.Authorization = `Bearer ${currentToken}`;
      request.headers.Accept = 'application/json';
      request.headers['Content-Type'] = 'application/json';
    } else {
      request.headers.Accept = 'application/json';
      request.headers['Content-Type'] = 'application/json';
    }
    return request;
  }, (error) => {
    return Promise.reject(error);
  });

  axiosInstance.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (!error.response) {
      return Promise.reject(error);
    }
    return error.response;
  });
  return axiosInstance;
};

export default AxiosInstance;